// src/pages/platform/AboutPArena.tsx

import React from "react";

import {
  Link,
} from "react-router-dom";

import "./PlatformPages.css";


const AboutPArena: React.FC = () => {

  return (
    <main className="platform-page">

      <section className="platform-hero">

        <div className="platform-hero-glow" />

        <div className="platform-hero-content">

          <nav
            className="platform-breadcrumb"
            aria-label="Breadcrumb"
          >
            <Link to="/">
              P-ARENA
            </Link>

            <span>/</span>

            <strong>
              About P-ARENA
            </strong>
          </nav>


          <div className="platform-emblem">
            ♣
          </div>

          <p className="platform-eyebrow">
            OUR PLATFORM
          </p>

          <h1>
            About P-ARENA
          </h1>

          <p className="platform-hero-description">
            A digital game house built around
            card games, competition, community,
            and the experience of playing
            together.
          </p>

        </div>

      </section>


      <div className="platform-content">

        {/* =========================================== */}
        {/* STORY                                       */}
        {/* =========================================== */}

        <section className="platform-story">

          <div className="platform-story-number">
            01
          </div>

          <div className="platform-story-content">

            <p className="platform-mini-label">
              WHAT IS P-ARENA?
            </p>

            <h2>
              A Home for Digital
              Card Games
            </h2>

            <p>
              P-ARENA is a digital gaming
              platform designed to bring card
              games into a modern online
              environment.
            </p>

            <p>
              The Game House provides one place
              where players can discover games,
              learn their rules, build player
              profiles, track their performance,
              and compete through supported
              game modes.
            </p>

            <p>
              Fasoor is the first playable title
              in the P-ARENA collection, with
              additional games planned as the
              platform develops.
            </p>

          </div>

        </section>


        {/* =========================================== */}
        {/* PRINCIPLES                                  */}
        {/* =========================================== */}

        <section className="platform-section">

          <div className="platform-section-heading">

            <span>
              02
            </span>

            <div>
              <p>
                THE EXPERIENCE
              </p>

              <h2>
                What P-ARENA Is Built Around
              </h2>
            </div>

          </div>


          <div className="platform-values-grid">

            <article>
              <span>
                ♠
              </span>

              <h3>
                Games
              </h3>

              <p>
                A growing collection of card
                games brought together inside
                one Game House.
              </p>
            </article>


            <article>
              <span>
                ♥
              </span>

              <h3>
                Players
              </h3>

              <p>
                Player accounts, profiles, game
                history, wins, losses, and
                statistics create continuity
                across the platform.
              </p>
            </article>


            <article>
              <span>
                ♦
              </span>

              <h3>
                Competition
              </h3>

              <p>
                Games are designed around
                meaningful competition whether
                the opponent is AI, a friend,
                or another online player.
              </p>
            </article>


            <article>
              <span>
                ♣
              </span>

              <h3>
                Community
              </h3>

              <p>
                P-ARENA is designed to grow
                beyond individual games into a
                shared gaming community.
              </p>
            </article>

          </div>

        </section>


        {/* =========================================== */}
        {/* FIRST GAME                                  */}
        {/* =========================================== */}

        <section className="platform-highlight">

          <div>

            <p className="platform-mini-label">
              THE FIRST GAME
            </p>

            <h2>
              It Starts with Fasoor.
            </h2>

            <p>
              Fasoor introduces the P-ARENA
              experience with strategic card
              capture, scoring, Soors, AI
              opponents, player statistics,
              and competitive gameplay.
            </p>

            <div className="platform-inline-actions">

              <Link
                to="/lobby"
                className="platform-primary-button"
              >
                Play Fasoor
              </Link>

              <Link
                to="/guides/fasoor"
                className="platform-secondary-button"
              >
                Fasoor Guide
              </Link>

            </div>

          </div>


          <div className="platform-highlight-mark">
            F
          </div>

        </section>


        <section className="platform-cta">

          <div className="platform-suits">
            ♠ ♥ ♦ ♣
          </div>

          <p className="platform-eyebrow">
            P-ARENA
          </p>

          <h2>
            More Games. One Game House.
          </h2>

          <p>
            Explore the current P-ARENA
            collection and see what is coming
            next.
          </p>

          <Link
            to="/game-house"
            className="platform-primary-button"
          >
            Explore Game House
          </Link>

        </section>

      </div>

    </main>
  );
};


export default AboutPArena;